module.exports = __webpack_public_path__ + "static/eurocash-555ecc102628343537bcbc351d1f5fc9.svg";